// @ts-nocheck

export const localeCodes =  [
  "en-US",
  "fr-FR"
]
export const localeLoaders = {
  "en-US": [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  "fr-FR": [
    {
      key: "locale_fr_46json_3676bfd9",
      load: () => import("#nuxt-i18n/3676bfd9" /* webpackChunkName: "locale_fr_46json_3676bfd9" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en-US",
    language: "en-US",
    name: "English (United States)"
  },
  {
    code: "fr-FR",
    language: "fr-FR",
    name: "Français"
  }
]

